import React from 'react';

function Page({children}) {
    return <section className="page">{children}</section>
}

export default Page;